import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeEvent } from '@ckeditor/ckeditor5-angular';
import { AngularFileUploaderComponent } from 'src/app/angular-file-uploader/angular-file-uploader.component';
import { data } from 'jquery';
import { CNPatient } from 'src/app/models/cnpatient';
import { CNProtocol } from 'src/app/models/cnprotocol';
import { ProtocolService } from 'src/app/services/protocol.service';
import * as ClassicEditor from 'src/assets/js/ck-editor/ckeditor.js';

@Component({
  selector: 'app-protocol-edit-dialog',
  templateUrl: './protocol-edit-dialog.component.html',
  styleUrls: ['./protocol-edit-dialog.component.scss']
})
export class ProtocolEditDialogComponent implements OnInit {

  public thumbnails: string[] = [];
  public documents: string[] = [];
  public patient: CNPatient = new CNPatient();
  public protocol: CNProtocol = new CNProtocol();
  public editor = ClassicEditor;
  public editorConfig = {
    toolbar: [
      'heading',
      '|',
      'bold',
      'italic',
      'link',
      'bulletedList',
      'numberedList',
      'blockQuote'
    ]
  };
  public afuConfig = {};

  @ViewChild('scanUpload') private certUpload: AngularFileUploaderComponent;

  constructor(private dialogRef: MatDialogRef<ProtocolEditDialogComponent>, @Inject(MAT_DIALOG_DATA) data,
              private protocols: ProtocolService) {
    if (typeof data.patient !== 'undefined') {
      this.patient = data.patient;
    }
    if (typeof data.protocol !== 'undefined') {
      this.protocol = data.protocol;
    } else {
      this.protocol = new CNProtocol();
    }
    this.afuConfig = {
      multiple: false,
      formatsAllowed: '.pdf,.png,.jpg,.jpeg',
      uploadAPI:  {
        url: '/api/v1/fr/patient/' + this.patient.id + '/protocol/document'
      },
      theme: 'attachPin',
      attachPinText: 'Sélectionner un document',
      hideProgressBar: true,
      hideResetBtn: true,
      hideSelectBtn: true
    };
  }

  ngOnInit(): void {
    this.loadDocuments();
  }

  private loadDocuments() {
    this.protocols.protocolThumbnails(this.patient, this.protocol).subscribe(result => {
      this.thumbnails = result;
    });
    this.protocols.protocolDocuments(this.patient, this.protocol).subscribe(result => {
      this.documents = result;
    });
  }

  editorContentChange({ editor }: ChangeEvent ) {
    
  }

  save(): void {

  }

  ocr(): void {
    this.protocols.ocr(this.patient, this.protocol).subscribe(result => {
      if (Array.isArray(result)) {
        result.forEach(part => {
          this.protocol.value += '<br>';
          this.protocol.value += part;
        });
      } else {
        this.protocol.value += '<br>';
        this.protocol.value += result;
      }
    });
  }

  certificateUpload(event) {
    if (event.status === 200) {
      const response = event.body;
      if (response.success === true) {
        this.loadDocuments();
      }
    }
  }
}
